module.exports = __webpack_public_path__ + "img/loading-block.5d6f3213.svg";